export default function InPatient({ patient }) {
    return (
        <div>
            <h4>In Patient UI</h4>

            {/* Example fields */}
            <p><strong>Name:</strong> {patient.name}</p>
            <p><strong>Category:</strong> {patient.category}</p>

            {/* later you can add */}
            {/* admission date, ward, bed, doctor, reports, etc */}
        </div>
    );
}
